/**
 * Punktacja Złata Přilba / Zlatá Stuha — logika z zlataprilba.js (bez jQuery).
 */

import { qsa } from './dom.js';
import { formatMatchScore, getTeamScore } from './scoring-general.js';

function getZlataScore() {
    const homeEls = document.querySelectorAll('.home-score');
    const awayEls = document.querySelectorAll('.away-score');
    const homeEl = homeEls.length ? homeEls[homeEls.length - 1] : null;
    const awayEl = awayEls.length ? awayEls[awayEls.length - 1] : null;
    const scoreEl = document.querySelector('.match-score__value')
        || document.querySelector('.match-score');

    if (!scoreEl) {
        return;
    }

    if (homeEl && awayEl) {
        scoreEl.textContent = formatMatchScore(homeEl.textContent, awayEl.textContent);
    } else {
        scoreEl.textContent = '0 : 0';
    }
}

export function getZlataPoints() {
    qsa('tr[data-rider]').forEach((row) => {
        const rider = row.getAttribute('data-rider');
        const group = row.getAttribute('data-group');
        let start = 0;
        let end = 0;
        let col = 0;

        if (group === '0') {
            start = 0;
            end = 2;
        } else if (group === '1') {
            start = 0;
            end = 2;
            if (document.querySelector("tr[data-rider='" + rider + "'][data-group='" + (parseInt(group, 10) - 1) + "']")) {
                start = 3;
                end = 5;
            }
        } else if (group === '2') {
            start = 3;
            end = 5;
            if (document.querySelector("tr[data-rider='" + rider + "'][data-group='" + (parseInt(group, 10) - 2) + "']")) {
                start = 6;
                end = 8;
            }
        }

        const spans = document.querySelectorAll("span[data-rider='" + rider + "'], span[data-changer='" + rider + "']");

        for (let i = start; i <= end; i++) {
            const span = spans[i];
            if (!span) {
                continue;
            }

            const changer = span.getAttribute('data-changer');
            let point;

            if (changer !== null && changer === rider) {
                point = span.innerHTML;
                const cell = row.querySelector('td:nth-child(' + (col + 3) + ')');
                if (cell) {
                    cell.innerHTML = point;
                }
                col++;
            } else if (changer !== null) {
                // data-changer wskazuje innego zawodnika — komórka pozostaje bez zmiany
                continue;
            } else {
                point = span.innerHTML;
                const cell = row.querySelector('td:nth-child(' + (col + 3) + ')');
                if (cell) {
                    cell.innerHTML = point;
                }
                col++;
            }
        }
    });

    qsa('tr[data-rider]').forEach((row) => {
        const cells = Array.from(row.querySelectorAll('td:not(:last-child)')).slice(2);
        const sorted = cells.slice().sort((a, b) => {
            let vA = parseInt(a.innerHTML, 10);
            let vB = parseInt(b.innerHTML, 10);

            if (Number.isNaN(parseInt(a.innerHTML, 10))) {
                vA = 0;
            }
            if (Number.isNaN(parseInt(b.innerHTML, 10))) {
                vB = 0;
            }

            return vA < vB ? -1 : vA > vB ? 1 : 0;
        });

        let sum = 0;
        let vA = parseInt(sorted[1].innerHTML, 10);
        let vB = parseInt(sorted[2].innerHTML, 10);

        if (Number.isNaN(parseInt(sorted[1].innerHTML, 10))) {
            vA = 0;
        }
        if (Number.isNaN(parseInt(sorted[2].innerHTML, 10))) {
            vB = 0;
        }

        sum += vA + vB;
        sorted[1].classList.add('active');
        sorted[2].classList.add('active');

        const sumCell = row.querySelector('td:last-child');
        if (sumCell) {
            sumCell.innerHTML = String(sum);
        }
    });
}

/** Przelicza tabelę Złaty z DOM przebiegu — sync z pollingiem course.php. */
export function refreshZlataFromCourse() {
    getZlataPoints();
    getZlataScore();
    getTeamScore();
}

export function initZlataScoring() {
    refreshZlataFromCourse();
    window.setTimeout(refreshZlataFromCourse, 1000);
    // Zapasowy tick — główna synchronizacja jest w onDone pollingu przebiegu.
    window.setInterval(refreshZlataFromCourse, 16000);
}
